import { useEffect } from 'react';
import useSWR from 'swr';
import { SWR_KEYS } from 'constants/constants';
import { getCurrenciesTableListing } from 'services/organization/currency.service';
import { ICurrencyTableItem } from 'types/currency.types';
import { displayErrorNotification } from 'utils/displayNudosStandardNotifications';

/**
 * Obtiene el listado de monedas para la tabla, con búsqueda opcional por nombre o código.
 */
export function useCurrenciesTableListing(search?: string) {
  const normalizedSearch = search?.trim() ?? '';

  const {
    data: currenciesTableListing,
    error: currenciesError,
    isLoading,
    mutate: mutateCurrenciesTableListing
  } = useSWR<ICurrencyTableItem[]>(
    [SWR_KEYS.currencies, normalizedSearch],
    () => getCurrenciesTableListing(normalizedSearch || undefined),
    {
      revalidateOnFocus: false
    }
  );

  const areCurrenciesLoading = isLoading && currenciesTableListing === undefined;

  useEffect(() => {
    if (currenciesError && currenciesTableListing === undefined) {
      displayErrorNotification();
    }
  }, [currenciesError, currenciesTableListing]);

  return { currenciesTableListing, currenciesError, areCurrenciesLoading, mutateCurrenciesTableListing };
}
